import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow, TableCell, Box, Tooltip } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { formatDate } from '../../../../utils/formatDate';
import { ROUTES, getRouteWithParam } from '../../../../constants/routes';
import { More } from '../More';
import { getMailingColorStatus } from '../../../mailing/constants';
import { DISABLED_CONTROL_TOOLTIP } from '../../../../constants/variables';

export const BonusesTableBody = ({ data, setCurID, setIsSuccessModal, permissions = {}, setIsOnApproveModal, setIsApproveModal, setIsRejectModal }) => {
  const history = useHistory();
  const [tooltip, setTooltip] = useState(false);

  const tableRow = (component, key) => tooltip ?
    <Tooltip
      key={key}
      title={DISABLED_CONTROL_TOOLTIP}
      arrow
      data-testid="Tooltip"
    >{component}</Tooltip> :
    component;

  const navigateToBonusDetail = (cardId) => history.push(getRouteWithParam(ROUTES.BONUSES_DETAIL_EVENT, ':id', cardId));

  return (
    <TableBody data-testid="TableBody">
      {data?.map((card) => tableRow(
        <TableRow
          key={card.id}
          onClick={(e) => {
            if (!permissions.retrieve) {
              setTooltip(true);
            } else {
              e.target.localName !== 'svg' && navigateToBonusDetail(card.id)
            }
          }}
          onMouseLeave={() => setTooltip(false)}
          sx={{ cursor: permissions.retrieve ? 'pointer' : 'default' }}
          data-testid="TableRow"
        >
          <TableCell>
            <Box width="50px" sx={{ whiteSpace: 'normal', wordWrap: 'break-all' }}>{card.id}</Box>
          </TableCell>
          <TableCell>
            <Box width="210px">{card.trigger}</Box>
          </TableCell>

          <TableCell>
            <Box width="95">{formatDate(card.date_start, 'true')}</Box>
          </TableCell>
          <TableCell>
            <Box width="95px">{formatDate(card.date_end, 'true')}</Box>
          </TableCell>

          <TableCell sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
            <Box width="155px">{card?.company}</Box>
          </TableCell>


          <TableCell sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
            <Box width="155px">{card.service}</Box>
          </TableCell>
          <TableCell sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
            <Box width="105px">{card.package || '-'}</Box>
          </TableCell>

          <TableCell>
            <Box color={`${getMailingColorStatus(card.status)}`} data-testid={`status ${card.status}`}>{card.status === 'archive' ? 'Архив' : card.status}</Box>
          </TableCell>

          <TableCell onClick={(e) => e.stopPropagation()}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <More
                id={card.id}
                status={card.status}
                setCurID={setCurID}
                setIsSuccessModal={setIsSuccessModal}
                permissions={permissions}
                setIsOnApproveModal={setIsOnApproveModal}
                setIsApproveModal={setIsApproveModal}
                setIsRejectModal={setIsRejectModal}
              />
            </Box>
          </TableCell>
        </TableRow>,
        card.id
      ))}
    </TableBody>
  );
};

BonusesTableBody.propTypes = {
  data: PropTypes.array,
  setCurID: PropTypes.func,
  setIsSuccessModal: PropTypes.func,
  permissions: PropTypes.object,
  setIsOnApproveModal: PropTypes.func,
  setIsApproveModal: PropTypes.func,
  setIsRejectModal: PropTypes.func,
};
